import type {
	Breakpoint,
	BreakpointType,
} from '@deezer/next/services/types/breakpoints';

export const BREAKPOINT_LIST: Breakpoint[] = [
	'base',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
];

// TODO redo / remove
export const getNextBreakpoint = (
	allBreakpoints: string[],
	currentBreakpoint: string,
): string | undefined => {
	const orderedBreakpoints = BREAKPOINT_LIST.filter(b =>
		allBreakpoints.includes(b),
	);

	return orderedBreakpoints[
		orderedBreakpoints.findIndex(b => b === currentBreakpoint) + 1
	];
};

export const getPreviousBreakpoint = (
	allBreakpoints: string[],
	currentBreakpoint: Breakpoint,
): string | undefined => {
	const previousBreakpoints = BREAKPOINT_LIST.slice(
		0,
		BREAKPOINT_LIST.indexOf(currentBreakpoint),
	).filter(b => allBreakpoints.includes(b));

	return previousBreakpoints[previousBreakpoints.length - 1];
};

export const getBreakpointValue = <T>(
	responsiveValue: BreakpointType<T>,
	breakpoint: Breakpoint,
	defaultValue?: T,
) => {
	if (typeof responsiveValue[breakpoint] !== 'undefined') {
		return responsiveValue[breakpoint];
	}
	const previousBreakpoint = getPreviousBreakpoint(
		Object.keys(responsiveValue),
		breakpoint,
	) as Breakpoint;
	if (
		previousBreakpoint &&
		typeof responsiveValue[previousBreakpoint] !== 'undefined'
	) {
		return responsiveValue[previousBreakpoint];
	}

	return defaultValue;
};
